module.exports = "/static/assets/ecf8aab29858b1233a5214116e8da517.png";